import React, {Component} from 'react';
import './global.css';
import NavBar from './NavBar';
import PageFooter from './PageFooter';

let _this;

class HowToRecordCall extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;
    }

    componentDidMount() {
        // setCurrentScreen(analytics, window.location.pathname);
        // logEvent(analytics, 'screen_view')
    }

    render() {
        return <div className="container">
            <NavBar navigate={this.props.navigate} current='' />
            <br/>
            <p className="normal">
                <h1>How to Record Phone Calls on Your iPhone or Android</h1>
            </p>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <h2 className="policy">Quick Overview</h2>
                    <p>
                        <b>A Call Recorder</b> uses a three-way calling technique to record your calls — no special
                        hardware required. Our server calls you back, merges the lines, and saves the audio to the
                        cloud so you can listen to or transcribe it any time.
                    </p>
                    <p>
                        Both parties are notified with an announcement: <b>"The Call Is Being Recorded"</b>.
                        Always check your local laws before recording a call.
                    </p>
                </div>
            </div>
            <br/>
            <div id="article">
                <p className="normal"><h2>Step 1 — Record an outgoing call</h2></p>
                <p>
                    Open <b>A Call Recorder App</b> and tap the <b>"Record A Call"</b> button (bottom-right).
                    Enter or select the destination number, then press <b>"Start"</b>. You will receive a
                    call-back from our server within seconds — answer it. Our server then dials the other party
                    and merges both lines. Recording begins automatically and both sides hear the recording
                    announcement.
                </p>
                <p>
                    When either party ends the call, recording stops and the audio file is saved to your
                    <b> Recorded Calls</b> list instantly.
                </p>
            </div>
            <br/>
            <div id="article">
                <p className="normal"><h2>Step 2 — Record an incoming or ongoing call</h2></p>
                <p>
                    Answer the incoming call normally, then switch to <b>A Call Recorder App</b> and tap
                    <b> "Merge &amp; Record"</b> (bottom-left). Our server calls you back — tap
                    <b> "Hold &amp; Accept"</b> on the native call-manager screen, then tap the
                    standard <b>Merge Calls</b> button. Recording starts as soon as all three lines are merged.
                </p>
                <p>
                    <b>Important:</b> after the call ends, always return to the app to confirm recording has
                    stopped, to avoid unexpected charges.
                </p>
            </div>
            <br/>
            <div id="article">
                <p className="normal"><h2>Step 3 — Play back the recording</h2></p>
                <p>
                    Tap <b>Recorded Calls</b> in the app to see all your recordings. Tap any item to open it,
                    then tap <b>Play</b>. Use the slider to jump to any point in the conversation.
                </p>
            </div>
            <br/>
            <div id="article">
                <p className="normal"><h2>Step 4 — Request a transcription</h2></p>
                <p>
                    Open a recording and tap <b>"Request Transcription"</b>. Select the primary language of the
                    conversation and tap <b>"Request"</b>. You will receive a notification when the transcription
                    is ready. Tap <b>"See Transcription"</b> to read, copy, or share the text.
                </p>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <h2 className="policy">Need a detailed walkthrough?</h2>
                    <p>
                        Visit our <a href="/call-recorder-and-transcriber-user-guide" role="button"
                            onClick={() => _this.props.navigate('UserGuide')}>full Tutorial</a> for
                        step-by-step screenshots, or check the{' '}
                        <a href="/call-recorder-and-transcriber-frequently-asked-questions" role="button"
                            onClick={() => _this.props.navigate('FAQ')}>FAQ</a> for common questions.
                        Still need help? <a href="/answer-solutions-contact" role="button"
                            onClick={() => _this.props.navigate('ContactUs')}>Contact Support</a>.
                    </p>
                </div>
            </div>
            <br/>
            <PageFooter navigate={this.props.navigate} current='' />
            <br/>
        </div>
    }
}

export default HowToRecordCall;
